import { DataBean } from "../DataBean";

export class ConsolidatePAC extends DataBean {

    public async getConsolidatePACCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_getConsolidatePACCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }

    public async getConsolidatePACRender(page:number|null,rows:number|any,properties:any): Promise<any> {
        return this.getCustomService("FinanceCore", "com.advantage.shared.Report_getConsolidatePACRender_Number_Number_java.util.Map", 
            [page,rows,properties]);
    }
    public async importPAC(year:number,budgetType:number,budgetResource:number,budgetSource:number,data:string): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_importPAC_Number_Number_Number_Number_String", 
            [year,budgetType,budgetResource,budgetSource,data]);
    }
    public async consolidatePACByMonth(year:number,month:number): Promise<any> {
        return this.getCustomService("FinanceCore", "com.advantage.shared.Report_consolidatePACByMonth_Number_Number", 
            [year,month]);
    }
    public async getDetalleOBPACRender(year:number,month:number,budgetStr:string,budgetType:number,budgetResource:number,budgetSource:number): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_getDetalleOBPACRender_Number_Number_String_Number_Number_Number", 
            [year,month,budgetStr,budgetType,budgetResource,budgetSource]);
    }
    public async getDetalleCEPACRender(year:number,month:number,budgetStr:string,budgetType:number,budgetResource:number,budgetSource:number): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_getDetalleCEPACRender_Number_Number_String_Number_Number_Number", 
            [year,month,budgetStr,budgetType,budgetResource,budgetSource]);
    }



 
}